import {
    post
} from './request'

// 专题专栏类型列表
export const getCategoryZhuanti = data => post('/index/zt_list', data)
export const getCategoryZhuanti_xin = data => post('/index/zt_list_new', data)
// 专题类类型列表页
export const getCategoryZhuantiPage = data => post('/index/zt_cate_list', data)
// 推荐专题文章列表
export const getIndexZhuanti = data => post('/index/zt_switch', data)
// 
export const getZhuantiOne = data => post('/index/zt_detail', data)